import React from 'react'
import styled from 'styled-components'

import { ReactComponent as SignOutIcon } from '../../../../assets/svgs/sign-out.svg'
import { redirect, ROUTES } from '../../../routes/routes'
import { clearCachedUser } from '../../../storage/storageRepository'
import { theme } from '../../../theme'
import { Button } from '../../uikit'

const Container = styled.div`
  background-color: ${theme.colors.lightBg};
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: ${theme.colors.greyText};
  font-weight: ${theme.fontWeight.medium};
`

const EmailLink = styled.a`
  text-decoration: underline;
`

const SignOutButtonComponent = styled(Button)`
  background-color: ${theme.colors.white};
`

export const SignOutButton = ({ className }: { className?: string }) => {
  const handleSignOut = () => {
    clearCachedUser()
    redirect(ROUTES.LOGIN)
  }

  return (
    <Container className={className}>
      <TextContainer>
        <div>Need assistance?</div>
        <div>
          Email{' '}
          <EmailLink href="mailto:support@altovita.com">
            support@altovita.com
          </EmailLink>
        </div>
      </TextContainer>

      <SignOutButtonComponent
        isFullWidth
        icon={<SignOutIcon />}
        onClick={handleSignOut}
        mode="borderedOnly"
      >
        Log out
      </SignOutButtonComponent>
    </Container>
  )
}
